<template>
  <div id="content">
    <form>
      <div class="inner">
        <h1 v-translate>Optimalizace</h1>
      </div>
      <div class="responsiveTabs">
        <div class="tabs_content">
          <section>
            <div class="left">
              <h2 v-translate>Smazání cache</h2>
            </div>
            <div class="right">
              <div class="field_left">
                <filter-checkbox
                    id="clear_change_queue"
                    p-class="field send_all"
                    v-model="clearChangeQueue"
                >
                  <translate class="translate">Promazat frontu změn</translate>
                </filter-checkbox>
              </div>
              <div class="field_left">
                <filter-checkbox
                    id="all_devices"
                    p-class="field"
                    v-model="deleteAllCache"
                >
                  <translate class="translate">Všechna zařízení</translate>
                </filter-checkbox>
              </div>
              <div class="field_left">
                <filter-checkbox
                    id="include_inactive_devices"
                    p-class="field"
                    v-model="includeInactiveDevices"
                >
                  <translate class="translate">Zahrnout neaktivní zařízení</translate>
                </filter-checkbox>
              </div>
              <div class="field checkboxes">
                <radio-input
                    id="or"
                    name="or_and"
                    p-class="field"
                    v-model="orAnd"
                    :val="orAnd"
                    :disabled="deleteAllCache"
                >
                  <translate class="translate">Sjednocení výběru</translate>
                </radio-input>
                <radio-input
                    id="and"
                    name="or_and"
                    p-class="field send_all"
                    v-model="orAnd"
                    :val="orAnd"
                    :disabled="deleteAllCache"
                >
                  <translate class="translate">Průnik výběru</translate>
                </radio-input>
              </div>
              <multiselect-searchbox
                  :searchFunction="searchOperators"
                  v-model="operator_ids"
                  :show-id="true"
                  :disabled="deleteAllCache"
              ><translate>Název operátora</translate></multiselect-searchbox>
              <multiselect-searchbox
                  :searchFunction="searchServices"
                  v-model="service_ids"
                  :show-id="true"
                  :disabled="deleteAllCache"
              ><translate>Název služby</translate></multiselect-searchbox>
              <multiselect-searchbox
                  :searchFunction="searchPackages"
                  v-model="package_ids"
                  :show-id="true"
                  :disabled="deleteAllCache"
              ><translate>Název balíčku</translate></multiselect-searchbox>
              <div class="field_left">
                <p class="btn_right">
                  <input type="submit"
                         class="btn"
                         :value="'Potvrdit' | translate"
                         @click.prevent.stop="submit"
                  >
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import message from "@/components/mixins/message"
export default {
  name: "Optimization",
  mixins: [message],
  data() {
    return {
      clearChangeQueue: false,
      deleteAllCache: false,
      includeInactiveDevices: false,
      operator_ids: [],
      service_ids: [],
      package_ids: [],
      orAnd: 'or',
    }
  },
  created(OptimizationService, OperatorService, ServiceService, PackageService) {
    this.optimizationService = OptimizationService
    this.operatorService = OperatorService
    this.serviceService = ServiceService
    this.packageService = PackageService

  },
  computed: {},
  methods: {
    searchOperators(search, selectAll = false) {
      return this.operatorService.searchOperatorsForRecipients({search: search, select_all: selectAll})
    },
    searchServices(search, selectAll = false) {
      return this.serviceService.searchServicesByNameOrId({search: search, select_all: selectAll})
    },
    searchPackages(search, selectAll = false) {
      return this.packageService.searchPackagesByNameOrId({search: search, select_all: selectAll})
    },
    submit() {
      let params = {}
      if (this.deleteAllCache) {
        params = {
          'clear_change_queue': this.clearChangeQueue,
          'delete_all_cache': this.deleteAllCache,
          'include_inactive_devices': this.includeInactiveDevices,
        }
      } else {
        params = {
          'clear_change_queue': this.clearChangeQueue,
          'delete_all_cache': this.deleteAllCache,
          'or_and': this.orAnd,
          'operators': this.operator_ids,
          'services': this.service_ids,
          'channel_packages': this.package_ids,
          'include_inactive_devices': this.includeInactiveDevices,
        }
      }

      this.setLoadingMessage()
      this.optimizationService.clearCache(params)
          .then(() => {
            this.setSuccessMessage()
          })
          .catch((error) => {
            this.setErrorMessage(error['error_message'])
          })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/optimization/Optimization.vue